import {
  FETCH_FIXTURE_CIRCUIT_CONFIG_PENDING,
  FETCH_FIXTURE_CIRCUIT_CONFIG_REJECTED,
  FETCH_FIXTURE_CIRCUIT_CONFIG_FULFILLED,
} from "../../constants/fixtureCircuitConfig";

const initialState = {
  loading: false,
  error: false,
  success: false,
  data: null,
};

const fixtureCircuitConfig = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_FIXTURE_CIRCUIT_CONFIG_PENDING:
      return {
        ...state,
        loading: true,
        error: false,
        success: false,
        data: state.data ? state.data : null,
      };
    case FETCH_FIXTURE_CIRCUIT_CONFIG_REJECTED:
      return {
        ...state,
        loading: false,
        error: true,
        success: false,
        data: null,
      };
    case FETCH_FIXTURE_CIRCUIT_CONFIG_FULFILLED:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
        data: action?.payload?.data?.Data,
      };
    default:
      return state;
  }
};

export default fixtureCircuitConfig;
